import { Grid, Box } from '@mui/material';
// TEMPORARY — Pending Requirements hidden; uncomment to re-enable
// import PendingRequirementsBlock, { isPendingRequirementsVisible } from './PendingRequirementsBlock';
import { isShipmentForwarded } from '../../../utils/pendingRequirements';
import React, { useEffect, useState } from 'react';
import ProductDescription from './ProductDescription';
import ShipmentTypeDetails from './ShipmentTypeDetails';
import BoxList from './BoxList';
import TotalValues from './TotalValue';
import CreateShipmentContext from '../../../context/CreateShipment';
import { createShipmentContextType } from '../../../types/shipment';
import Actions from '../Actions';
import { getRates, setCreateShipmentCSP } from '../../../store/reducers/GetRates';
import { useDispatch, useSelector } from 'react-redux';
import { SHIPMENT_TYPES } from '../../GetRatesV2/Constant';
import { AppDispatch, RootStateType } from '../../../store';
import NoCSPFound from '../../GetRatesV2/CSPList/NoCSPFound/NoCSPFound';
import ViewAction from '../../ViewSingleShipment/ViewAction';
import { buildRateRequestPayload } from '../../../services/getRatePayload';

function ShipmentDetails({
  removeShipmentInfo,
  showViewMoreAction,
  isShipmentDetailsWriteAllowed,
}: {
  removeShipmentInfo?: boolean;
  showViewMoreAction?: boolean;
  isShipmentDetailsWriteAllowed?: boolean;
}) {
  const [viewMore, setViewMore] = useState<boolean>(true);

  const dispatch = useDispatch<AppDispatch>();
  const {
    activeStep,
    setActiveStep,
    setShowRates,
    boxes,
    consignee,
    shipper,
    totalShipmentValue: value,
    actualWeight,
    shipmentType,
    boxValidation,
    userId,
    pickupType: { selectedWearhouseAddress, warehouse },
    pickupType,
    packageData,
    shipmentById,
    pendingRequirements: contextPendingRequirements,
    extraDetails,
  } = React.useContext(CreateShipmentContext) as createShipmentContextType;

  const isForwarded = isShipmentForwarded(shipmentById);
  const pendingRequirements = isForwarded ? [] : contextPendingRequirements || [];
  const isNextDisabled = !boxValidation || pendingRequirements.length > 0;

  const rates = useSelector((state: RootStateType) => state.getRates);
  const { chareableWeight = { maxChargeableWt: 0 } } = useSelector((state: RootStateType) => state.getRates);

  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { countriesNameObj = {}, countries = [] } = useSelector((state: RootStateType) => state.global);
  const { name = '' } = organizationData || {};

  useEffect(() => {
    if (rates.redirectToCreateShipmentCSP) {
      setActiveStep(activeStep + 1);
      dispatch(setCreateShipmentCSP(false));
    }
  }, [rates.redirectToCreateShipmentCSP, activeStep, setActiveStep, dispatch]);

  function handleGetRates() {
    if (isNextDisabled) {
      window.dispatchEvent(new CustomEvent('validate-shipment-details'));
      return;
    }

    const resolvedFreight =
      shipmentType?.freight !== undefined && shipmentType?.freight !== ''
        ? Number(shipmentType.freight) || 0
        : extraDetails?.freight !== undefined && extraDetails?.freight !== ''
        ? Number(extraDetails.freight) || 0
        : 0;
    const resolvedFreightInsurance =
      shipmentType?.freightInsurance !== undefined && shipmentType?.freightInsurance !== ''
        ? Number(shipmentType.freightInsurance) || 0
        : extraDetails?.freightInsurance !== undefined && extraDetails?.freightInsurance !== ''
        ? Number(extraDetails.freightInsurance) || 0
        : 0;
    const resolvedIncoterm = shipmentType?.incoterm || extraDetails?.incoterm || 'FOB';

    const payload = buildRateRequestPayload({
      destination: consignee,
      source: selectedWearhouseAddress?.label ? selectedWearhouseAddress : shipper,
      shipmentType: shipmentType.type,
      userId,
      weight: chareableWeight?.maxChargeableWt || actualWeight || 0,
      value,
      boxes,
      unitOfMeasurement: shipmentType.unit,
      document: shipmentType.type === SHIPMENT_TYPES[1].value,
      insurance: packageData.insurance,
      packaging: packageData.packaging,
      currency: shipmentType.currency,
      dropOff: pickupType.type === 'dropOff',
      organizationName: name === 'Cargo Solutions Network',
      dutyCharge: shipmentType.dutyCharge,
      countriesNameObj,
      countries,
      rateFor: 'create-shipment',
      freight: resolvedFreight,
      freightInsurance: resolvedFreightInsurance,
      incoterm: resolvedIncoterm,
    });

    if (pickupType.type === 'dropOff') {
      payload.warehouseAddress = selectedWearhouseAddress;
      payload.warehouseId = warehouse;
    }

    dispatch(getRates([payload, false]));
  }

  return (
    <>
      <Grid container>
        {!removeShipmentInfo && (
          <Grid item xs={12}>
            <ShipmentTypeDetails pendingRequirements={pendingRequirements} />
          </Grid>
        )}
        <Grid item xs={12} sx={{ mt: 3 }}>
          <TotalValues />
        </Grid>
        {showViewMoreAction && (
          <Grid container justifyContent="flex-end" sx={{ mt: 1 }}>
            <ViewAction setViewMore={setViewMore} viewMore={viewMore} />
          </Grid>
        )}
        {(viewMore || !showViewMoreAction) && (
          <Grid container item xs={12} sx={{ mt: 3 }} spacing={2}>
            <Grid item lg={4} xl={3} md={4} sm={12} xs={12}>
              <BoxList writeAccess={isShipmentDetailsWriteAllowed} />
            </Grid>
            <Grid item lg={8} xl={9} md={8} sm={12} xs={12}>
              <ProductDescription writeAccess={isShipmentDetailsWriteAllowed} />
            </Grid>
          </Grid>
        )}
        {/* TEMPORARY — Pending Requirements hidden; uncomment to re-enable
        {isPendingRequirementsVisible(pendingRequirements, undefined, isForwarded) && (
          <Grid item xs={12} sx={{ mt: 3 }}>
            <PendingRequirementsBlock pendingRequirements={pendingRequirements} isForwarded={isForwarded} />
          </Grid>
        )}
        */}
      </Grid>
      {!removeShipmentInfo && (
        <Box sx={{ mt: 2, width: '100%' }}>
          <Actions onNext={handleGetRates} disableNext={isNextDisabled} />
        </Box>
      )}
      <NoCSPFound setShowRates={setShowRates} />
    </>
  );
}

export default ShipmentDetails;
